export function excludeAtIndex(array, index) {
  return [...array.slice(0, index), ...array.slice(index + 1)];
}
export function replaceAtIndex(array, index, newValue) {
  return [...array.slice(0, index), newValue, ...array.slice(index + 1)];
}